export default __webpack_public_path__ + "static/exotic_4-9181b29711a9d7a66189c19fced21451.webp";